import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

import { Provider } from 'react-redux'
import store from './store';

// macOS-like scrollbars on Windows/Linux (styles in index.css); Apple platforms keep their native bars
const platform = (navigator.userAgentData && navigator.userAgentData.platform) || navigator.platform || '';
if (!/mac|iphone|ipad|ipod/i.test(platform)) document.documentElement.classList.add('mac-scrollbars');

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root')
)